module.exports = __webpack_public_path__ + "static/media/integration.404fe050.svg";